function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#90C53D",
  fillRule: "evenodd",
  d: "M6.161 20H14a2 2 0 012 2v10.3L25.84 20H18a2 2 0 01-2-2V7.7L6.161 20zm7.176 19.885A1.999 1.999 0 0112 38V24H2a2 2 0 01-1.56-3.25l16-20a1.998 1.998 0 012.222-.636A1.996 1.996 0 0120 2v14h10c.77 0 1.47.442 1.805 1.134a2.004 2.004 0 01-.242 2.116l-16 20a1.997 1.997 0 01-2.225.636z"
});

function SvgWinWinGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDMyIDQwIj4KICAgIDxwYXRoIGZpbGw9IiM5MEM1M0QiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMTYxIDIwSDE0YTIgMiAwIDAgMSAyIDJ2MTAuM0wyNS44NCAyMEgxOGEyIDIgMCAwIDEtMi0yVjcuN0w2LjE2MSAyMHptNy4xNzYgMTkuODg1QTEuOTk5IDEuOTk5IDAgMCAxIDEyIDM4VjI0SDJhMiAyIDAgMCAxLTEuNTYtMy4yNWwxNi0yMGExLjk5OCAxLjk5OCAwIDAgMSAyLjIyMi0uNjM2QTEuOTk2IDEuOTk2IDAgMCAxIDIwIDJ2MTRoMTBjLjc3IDAgMS40Ny40NDIgMS44MDUgMS4xMzRhMi4wMDQgMi4wMDQgMCAwIDEtLjI0MiAyLjExNmwtMTYgMjBhMS45OTcgMS45OTcgMCAwIDEtMi4yMjUuNjM2eiIvPgo8L3N2Zz4K";
export { SvgWinWinGreen as ReactComponent };